import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import DashConsumoContratual from "../../../components/classes/DashConsumoContratual";

export default function ChartRecords03(props: ChartRecordsPropTypes) {
  const [seriesMixedChart, setSeriesMixedChart] = useState<{name: string, type: string, data: number[]}[]>([]);
  const [optionsMixedChart, setOptionsMixedChart] = useState<ApexCharts.ApexOptions>({});
  
  useEffect(()=>{

    var groupedByReferencia = props.dadosQuantidadeContrato?.reduce(function (r, a) {
      r[+a.referencia] = r[+a.referencia] || [];
      r[+a.referencia].push(a);
      return r;
  }, Object.create(null)) ?? [];

    var quantidadeUtilizada : number[] = [];

    var sortedReferencia = Object.keys(groupedByReferencia).sort((a, b) => +a - +b);

    sortedReferencia.forEach(key => {
      quantidadeUtilizada.push(groupedByReferencia[key].reduce((y: number, z: DashConsumoContratual)=> y + z.quantidadeProduzida ,0));
    });

    setSeriesMixedChart(
      [
        {
          name: "UTILIZADO",
          type: "column",
          data: quantidadeUtilizada
        }
      ]
    );

    setOptionsMixedChart(
      {
        ...optionsMixedChart,
        xaxis: {
          type: "category",
          categories: sortedReferencia
        },
      }
    );
    
  }, [props]);


  return (
    <div id="chart003" className="mixed-chart">
      <ReactApexChart
        options={optionsMixedChart}
        series={seriesMixedChart}
        type="line"
        height={270}
      />
    </div>
  );
}

interface ChartRecordsPropTypes {
  dadosQuantidadeContrato?: DashConsumoContratual[];
}
